import React from 'react';
import {
  footerBottomMost,
  footer_bottom_links,
  footer_social
} from '../../partnerStyles';
import * as IMAGES from '../../Images';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Event } from '../../Modules/LandingPageNew/Tracking/Track';

const FooterBottomLinks = props => {
  return (
    <div style={footer_bottom_links}>
      <div style={footer_social}>
        {props.globalData.universal_translations.facebook_link && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={props.globalData.universal_translations.facebook_link}
            onClick={() => {
              Event('footer', 'Clicked on facebook icon', '', '');
            }}
          >
            <img src={IMAGES.FACEBOOK} width="32px" alt="FACEBOOK" />
          </a>
        )}

        {props.globalData.universal_translations.instagram_link && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={props.globalData.universal_translations.instagram_link}
            onClick={() => {
              Event('footer', 'Clicked on instagram icon', '', '');
            }}
          >
            <img src={IMAGES.INSTAGRAM} width="32px" alt={'INSTAGRAM'} />
          </a>
        )}

        {props.globalData.universal_translations.twitter_link && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={props.globalData.universal_translations.twitter_link}
            onClick={() => {
              Event('footer', 'Clicked on twitter icon', '', '');
            }}
          >
            <img src={IMAGES.TWITTER} width="32px" alt={'TWITTER'} />
          </a>
        )}

        {props.globalData.universal_translations.youtube_link && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={props.globalData.universal_translations.youtube_link}
            onClick={() => {
              Event('footer', 'Clicked on youtube icon', '', '');
            }}
          >
            <img src={IMAGES.YOUTUBE} width="32px" alt={'YOUTUBE'} />
          </a>
        )}

        {props.globalData.universal_translations.pinterest_link && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={props.globalData.universal_translations.pinterest_link}
            onClick={() => {
              Event('footer', 'Clicked on pinterest icon', '', '');
            }}
          >
            <img src={IMAGES.PINTEREST} width="32px" alt={'PINTEREST'} />
          </a>
        )}
      </div>
      <div style={{ ...footerBottomMost }}>
        <span>2018-2019 © Oravel Stays Private Limited</span>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterBottomLinks);
